
import { Component } from "@angular/core";
import { RouterOutlet, RouterLink } from "@angular/router";
import {HrAdminWelcomeComponent } from "./welcome/welcome.component";
import { ResetPassDialogComponent } from "../authentication/reset-pass-dialog/reset-pass-dialog.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
 selector: 'app-hr-admin-dashboard',
  standalone: true,
  templateUrl: './hr-admin-dashboard.component.html',
  styleUrl: './hr-admin-dashboard.component.scss',
  imports: [HrAdminWelcomeComponent, RouterOutlet, RouterLink],
})
export class HrAdminDashboardComponent {
  constructor(private dialog: MatDialog) {}
  ngOnInit(): void {
    const storedUser = sessionStorage.getItem("currentUser");
    const user = storedUser ? JSON.parse(storedUser) : null;
    if (user && user.shouldRenewPassword) {
      this.onPassChange();
    }
  }
  private onPassChange() {
    const dialogConfig = this.dialog.open(ResetPassDialogComponent, {
      minWidth: "650px",
      width: "800px",
      maxHeight: "90vh",
      disableClose: true,
    });
    dialogConfig.afterClosed().subscribe((results) => {});
  }
}

